// extracted by mini-css-extract-plugin
export default {"qrCoreBlock":"QrCode_qrCoreBlock__oA3Lo"};